export function KeyboardHints() {
  return (
    <div className="flex-shrink-0 border-gray-200 border-t bg-gray-50 px-4 py-2">
      <div className="flex items-center justify-between text-gray-500 text-xs">
        <div className="flex gap-4">
          <div className="flex items-center gap-1">
            <kbd className="rounded bg-white px-1.5 py-0.5 font-mono">↑↓</kbd>
            <span>Navigate</span>
          </div>
          <div className="flex items-center gap-1">
            <kbd className="rounded bg-white px-1.5 py-0.5 font-mono">↵</kbd>
            <span>Select</span>
          </div>
          <div className="flex items-center gap-1">
            <kbd className="rounded bg-white px-1.5 py-0.5 font-mono">Esc</kbd>
            <span>Close</span>
          </div>
        </div>
      </div>
    </div>
  );
}
